import React from 'react';
import './Qhse.css';
import Avatar from '../Images/Qhse_1.jpeg'
import Footer from '../Component/NewFooter';

const qhseCards = [
  {
    title: 'Safety First',
    paragraphs: [
      'We prioritize the safety of all personnel by providing and maintaining a work environment that is free from hazards and conducive to overall well-being.',
    ],
  },
  {
    title: 'Quality Assurance',
    paragraphs: [
      'We are committed to delivering services that meet  client expectations, ensuring consistency, reliability, and adherence to industry standards and specifications.',
    ],
  },
  {
    title: 'Risk Assessment and Mitigation',
    paragraphs: [
      'We proactively identify hazards and environmental aspects associated with our operations. Through systematic risk assessments, we implement effective control measures to mitigate risks and prevent incidents.',
    ],
  },
  {
    title: 'Compliance with Regulations',
    paragraphs: [
      'We comply with all applicable National and International laws, regulations, and standards relating to quality, health, safety, and environmental management.',
    ],
  },
  {
    title: 'Emergency Preparedness',
    paragraphs: [
      'We maintain well-defined emergency response plans, procedures, and resources to effectively manage potential incidents and minimize their impact on people, assets, and the environment.',
    ],
  },
  {
    title: 'Environmental Responsibility',
    paragraphs: [
      'We conduct our operations with respect to the environment by preventing pollution, minimizing waste, and promoting the efficient use of resources to support sustainable development.',
    ],
  },
  {
    title: 'Continuous Improvement',
    paragraphs: [
      'We promote a culture of continual improvement through regular audits, performance monitoring, feedback mechanisms, and the implementation of corrective and preventive actions.',
    ],
  },
  {
    title: 'Training and Awareness',
    paragraphs: [
      'We provide continuous training and awareness programs to ensure that our employees and contractors are competent, informed, and equipped to identify and manage workplace hazards effectively.',
    ],
  },
  {
    title: 'Shared Responsibility',
    paragraphs: [
      'QHSE is a collective responsibility. All employees, contractors, and stakeholders are expected to actively participate in maintaining a safe, healthy, and environmentally responsible workplace.',
    ],
  },
];

const QHSE = () => {
  return (
    <>
      <div className="img_carrier">
        <img src={Avatar} alt="" />
      </div>

      <section className="qhse-section" aria-labelledby="qhse-title">
        <div className="qhse-section__header">
          <h2 className="qhse-section__title" id="qhse-title">Quality Health Safety and Environment(QHSE)</h2>
          <hr className="qhse-section__divider" />
        </div>

        <p className="qhse-section__intro">
          Jeyshawn Engineering Limited is fully committed to delivering quality engineering services
          while safeguarding the health, safety, and well-being of our employees, contractors,
          partners, stakeholders, and host communities. We are equally dedicated to protecting the
          environment and conducting our operations in a responsible and sustainable manner.
        </p>

        <div className="qhse-section__quote-box">
          <p className="qhse-section__quote">
            "Quality, Health, Safety, and Environment are not merely policies but fundamental principles that guide our operations."
          </p>
        </div>

        <p className="qhse-section__sub-intro">
          QHSE is a core value embedded in our business processes and decision-making, ensuring that
          all activities are carried out safely, efficiently, and in compliance with applicable standards.
        </p>

        <p className="qhse-section__policy-intro">
          Our QHSE Policy encompasses Quality, Health, Safety and Environmental Management based on
          the following commitments:
        </p>

        <div className="qhse-section__cards">
          {qhseCards.map((card) => (
            <div className="qhse-card" key={card.title}>
              <h3 className="qhse-card__title">{card.title}</h3>
              {card.paragraphs.map((para, i) => (
                <p className="qhse-card__text" key={i}>{para}</p>
              ))}
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </>
  );
};

export default QHSE;